module.exports = __webpack_public_path__ + "static/media/avironLogo.a86f2cfa.png";